import { faArrowTurnDownLeft, faX } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

const ProjectCount = ({ projectsReferenceActive, projectsReferenceRemoved }) => {
  const renderCount = (icon, count, style) => {
    return (
      <>
        <FontAwesomeIcon icon={icon} className="mx-1" style={style} /> {count}
      </>
    );
  };

  if (projectsReferenceActive >= 1 && projectsReferenceRemoved === 0) {
    return <span className="ml-2">({renderCount(faArrowTurnDownLeft, projectsReferenceActive)})</span>;
  } else if (projectsReferenceActive === 0 && projectsReferenceRemoved >= 1) {
    return <span className="ml-2">({renderCount(faX, projectsReferenceRemoved, { fontSize: '12px' })})</span>;
  } else {
    return (
      <span className="ml-2">
        ({renderCount(faArrowTurnDownLeft, projectsReferenceActive)},
        {renderCount(faX, projectsReferenceRemoved, { fontSize: '12px' })})
      </span>
    );
  }
};

export default ProjectCount;
